import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';
import {
  selectClientCurrency,
  selectCountrySelected,
  selectMainFilterSelectedAccount,
  selectMainFilterSelectedClient,
  selectMainPageNotes,
  selectStaticData,
} from '../../shared/layout/main.selectors';
import { distinctUntilChanged, filter, map, take, withLatestFrom } from 'rxjs/operators';
import { ColumnDef, CommonConstants, PageNotes, SortInfo, TableHeader } from '../../global/interfaces';

import { formatDate } from '../../global/dates';
// import { MosConfigurationService, PaginationInfo } from 'merceros-ui-components';
import { getDataUri } from '../../global/getDataUri';
import { DecimalService } from '../../global/pipes/decimal.pipe';
import { isEqual, sortBy } from 'lodash';
import { WindowResizeService } from '../../global/window-resize.service';
import {
  LoadValuationsPortfolioAction,
  LoadValuationsPricesAction,
  LoadValuationsTotalPricesAction,
  ResetValuationsDataAction,
  SetValuationsFromFilterAction,
  SetValuationsFundFilterAction,
  SetValuationsFundsFilterAction,
  SetValuationsPriceFilterAction,
  SetValuationsToFilterAction,
  SetValuationsTypeFilterAction,
  ValuationsCsvExportAction,
  LoadValuationsDatesAction
} from './valuations.actions';
import {
  CsvExportType,
  FULL_PRICE_TYPES,
  PRICE_TYPES,
  PriceType,
  Types,
  VALUATIONS_OPTIONS,
  ValuationsFund,
  ValuationsOption,
  ValuationsTableFund,
  ValuationsType,
  ValuationsTypes
} from './valuations.models';
import {
  selectValuationsChartPayload,
  selectValuationsDataLoading,
  selectValuationsDates,
  selectValuationsDatesMax,
  selectValuationsDatesMin,
  selectValuationsFilter,
  selectValuationsFromFilter,
  selectValuationsFundFilter,
  selectValuationsFunds,
  selectValuationsFundsFilter,
  selectValuationsLoading,
  selectValuationsPayloadFunds,
  selectValuationsPortfolio,
  selectValuationsPriceFilter,
  selectValuationsToFilter,
  selectValuationsTypeFilter
} from './valuations.selectors';
import { RGB_COLORS } from '../../global/colors';
import * as moment from 'moment';
import { StockChart } from '../../shared/charts/stockcharts.class';
import { XAxisOptions } from 'highcharts/highstock';
import { georgiaFontFamily, georgiaFontVfs } from '../../shared/pdfs/georgia-font';
import { pdfFooter, pdfHeader, pdfStyle } from '../../shared/pdfs/templates';
import { User } from '../administration/user/user.models';
import { selectAuthUser } from '../auth/auth.selectors';
import { selectConsultants } from '../features.selectors';
import { LoadClientConsultantAction } from '../features.actions';
import { CONFIG } from '../../../config';
import { isNullOrUndefined } from 'util';
import { PaginationInfo } from 'atlas-pagination';
import { DateTime } from 'luxon';
import { Actions, FieldSize } from 'atlas-cdk';
import { ToastService } from '../../shared/toaster_/toaster_.service';
import { DropdownPlacement, DropdownTriggerType } from 'atlas-menu';

const pdfFonts = require('pdfmake/build/vfs_fonts.js');
const pdfMake = require('pdfmake/build/pdfmake.js');

@Component({
  standalone: false,
  selector: 'dsp-valuations',
  templateUrl: 'valuations.container.html',
  styleUrls: ['valuations.container.scss']
})
export class ValuationsContainerComponent implements OnInit, OnDestroy {
  dropdownTriggerTypeCustom = DropdownTriggerType.Custom;
  dropdownTriggerTypeIconButton = DropdownTriggerType.IconButton;
  dropdownPlacementLeftStart = DropdownPlacement.LeftStart;
  sizeMedium = FieldSize.medium;
  sizeSmall = FieldSize.small;
  fieldSizes = FieldSize;
  headerDepartmentOptions = [

    { value: 'engineering', label: 'Engineering' },

    { value: 'product', label: 'Product' },

    { value: 'design', label: 'Design' },

    { value: 'operations', label: 'Operations' },

  ];
  headerCountryOptions = [

    { value: 'argentina', label: 'Argentina' },

    { value: 'chile', label: 'Chile' },

    { value: 'colombia', label: 'Colombia' },

    { value: 'mexico', label: 'Mexico' },

  ];
  public headers: ColumnDef[] = [
    {
      name: 'Name',
      column: 'name',
      sortable: true,
      displayLabel: 'Name',
      fieldKey: 'name',


    },
    {
      name: '',
      column: 'price',
      sortable: true,
      displayLabel: '',
      fieldKey: 'price',



    },
    {
      name: 'Units Held',
      column: 'units',
      sortable: true,
      displayLabel: 'Units Held',
      fieldKey: 'units',



    },
    {
      name: 'Last Valuation Date',
      column: 'latestValuation',
      sortable: true,
      displayLabel: 'Last Valuation Date',
      fieldKey: 'latestValuation',


    },
    {
      name: 'Closing Balance ($)',
      column: 'closing',
      sortable: true,
      displayLabel: 'Closing Balance ($)',
      fieldKey: 'closing',

    },
    {
      name: 'Actual (%)',
      column: 'actual',
      sortable: true,
      displayLabel: 'Actual (%)',
      fieldKey: 'actual',


    },
    {
      name: 'Strategic (%)',
      column: 'strategic',
      sortable: true,
      displayLabel: 'Strategic (%)',
      fieldKey: 'strategic',

    },
    {
      name: 'Range Min/Max (%)',
      column: 'range',
      sortable: true,
      displayLabel: 'Range Min/Max (%)',
      fieldKey: 'range',
    }
  ];

  public filterTypes: string[] = ['select', 'select', 'datepicker', 'datepicker'];
  public mobileFilterTypes: string[] = ['select', 'datepicker'];

  public options: ValuationsOption[] = VALUATIONS_OPTIONS;
  public prices: ValuationsOption[] = PRICE_TYPES;
  public fundsOptions: any[] = [];
  public price: string;

  public funds: string[];
  public fund: string;

  public from: string;
  public to: string;
  public asAt: string;
  public account: Object;
  public showRangeStrategic$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public chart: StockChart;

  public loading$: Observable<boolean>;
  public headers$: Observable<ColumnDef[]>;
  public type$: Observable<ValuationsType | PriceType>;
  public funds$: Observable<ValuationsFund[]>;
  public fundsOptionsForSingleSelect$: Observable<any[]>;
  public fundlist: ValuationsFund[] = new Array<ValuationsFund>();
  public minDate$: Observable<string | undefined>;
  public maxDate$: Observable<string | undefined>;
  public table$: Observable<ValuationsTableFund[]>;
  public tableLength$: BehaviorSubject<number> = new BehaviorSubject(0);
  public showTotal$: Observable<boolean>;
  public date$: Observable<string>;
  public pagination$: Observable<PaginationInfo>;


  public sort$: BehaviorSubject<SortInfo> = new BehaviorSubject<SortInfo>({ column: 'name', reverse: false });
  public isMobile$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public filterTypes$: BehaviorSubject<string[]> = new BehaviorSubject(this.filterTypes);
  public notes$: BehaviorSubject<PageNotes> = new BehaviorSubject<PageNotes>({} as PageNotes);
  public showData$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public subscription: Subscription = new Subscription();
  public user$: Observable<User | undefined>;
  public country = '';

  /**
   * Sort funds by name ignoring case
   *
   * @param f1 The first fund for comparison.
   * @param f2 The second element for comparison.
   */
  private static sortFunds(f1: ValuationsFund, f2: ValuationsFund): number {
    const f1Lower = f1.name.toLowerCase(),
      f2Lower = f2.name.toLowerCase();
    return f1Lower < f2Lower ? -1 : f1Lower > f2Lower ? 1 : 0;
  }

  private static getFromDate({ min, max }: { min: string; max: string }): string {
    const max5y = moment.utc(max).subtract(5, 'year');
    return moment.utc(min).isBefore(max5y) ? max5y.format() : min;
  }

  public constructor(
    private readonly store: Store<AppState>,
    private readonly cdr: ChangeDetectorRef,
    private readonly decimal: DecimalService,
    private readonly resize: WindowResizeService,
    private readonly _toasterService: ToastService
  ) {

    this.headers = this.headers.map((header, index) => {
      if (index > 0 && index <= 6) {
        return { ...header, disableSort: false, textAlign: 'right' };
      } else if (index === 7) {
        return { ...header, disableSort: true, textAlign: 'right' };
      } else {
        return { ...header };
      }

    });

    this.loading$ = this.selectLoading();
    this.headers$ = this.selectHeaders();
    this.minDate$ = this.selectMinDate();
    this.maxDate$ = this.selectMaxDate();
    this.type$ = this.selectTypeFilter();
    this.funds$ = this.selectFunds();
    // Transform funds$ to format expected by atlas-field-select
    this.fundsOptionsForSingleSelect$ = this.funds$.pipe(
      map(funds => funds.map(fund => ({
        label: fund.name,
        value: fund.fundId
      })))
    );
    this.table$ = this.selectTable();
    this.showTotal$ = this.selectShowTotal();
    this.date$ = this.selectDate();
    this.pagination$ = this.selectPagination();
    this.user$ = this.store.pipe(select(selectAuthUser));
  }

  public ngOnInit(): void {
    // this.createBaseChart();
    this.subscription.add(this.subscribeSelectedCountry());
    this.subscription.add(this.createBaseChart());
    this.subscription.add(this.loadValuationMetricsDates());
    this.subscription.add(this.subscribeLoadValuationsPortfolio());
    this.subscription.add(this.subscribeLoadValuationsPrices());
    this.subscription.add(this.subscribeLoadValuationsTotalPrices());
    this.subscription.add(this.subscribePriceFilter());
    this.subscription.add(this.subscribeInitialFundFilter());
    this.subscription.add(this.subscribeFundFilter());
    this.subscription.add(this.subscribeInitialFromFilter());
    this.subscription.add(this.subscribeInitialToFilter());
    this.subscription.add(this.setInitialFromToFilter());
    this.subscription.add(this.subscribeFundsFilter());
    this.subscription.add(this.subscribeResetFilters());
    this.subscription.add(this.subscribeResetData());
    this.subscription.add(this.subscribeIsMobile());
    this.subscription.add(this.subscribeFilterTypes());
    this.subscription.add(this.subscribeNotes());
    this.subscription.add(this.subscribeChartData());
    this.subscription.add(this.subscribeShowData());
    this.subscription.add(this.subscribeFundList());
    this.subscription.add(this.subscribeConsultantLoad());
  }

  public subscribeSelectedCountry(): Subscription {
    return this.store.pipe(
      select(selectCountrySelected)
    ).subscribe(country => {
      this.country = country;
    });
  }

  public ngOnDestroy(): void {
    this.store.dispatch(new ResetValuationsDataAction());
    this.from = '';
    this.to = '';
    this.subscription.unsubscribe();
    this.cdr.detach();
  }

  public loadValuationMetricsDates(): Subscription {
    return this.store.pipe(
      select(selectMainFilterSelectedAccount),
      distinctUntilChanged(isEqual),
    ).subscribe(account => {
      if (!!account) {
        this.account = account;
        this.store.dispatch(new LoadValuationsDatesAction({ account: account._id }));
      }
    });
  }

  private subscribeConsultantLoad(): Subscription {
    return this.user$.subscribe(user => {
      if (user) {
        this.store.pipe(select(selectMainFilterSelectedClient)).subscribe(client => {
          if (!isNullOrUndefined(client)) {
            this.store.dispatch(new LoadClientConsultantAction(client._id));
          }
        });
      }
    });
  }

  public onChangeType(event: ValuationsType | PriceType): void {
    this.store.pipe(
      select(selectValuationsTypeFilter),
      take(1),
      filter(type => type !== event)
    ).subscribe(() => {
      this.store.dispatch(new SetValuationsTypeFilterAction(event));
    });
  }

  public onChangePrice(event: PriceType): void {
    if (!!event) {
      this.store.pipe(
        select(selectValuationsPriceFilter),
        take(1),
        filter(price => price !== event)
      ).subscribe(() => {
        this.store.dispatch(new SetValuationsPriceFilterAction(event));
      });
    }
  }

  public onChangeFunds(event: string[]): void {
    this.store.dispatch(new SetValuationsFundsFilterAction(event));
  }

  public onChangeFund(event: string): void {
    if (event) {
      this.store.dispatch(new SetValuationsFundFilterAction([event]));
    }
  }

  /**
   * Maintains From filter value in store
   * Sets extreme min value on chart
   */
  public onChangeFrom(event: string): void {
    const formatted = DateTime.fromJSDate(event).toFormat('yyyy-MM-dd');
    const dateWithTimeZone = new Date(formatted + 'T00:00:00.000Z').toISOString()
    this.store.pipe(
      select(selectValuationsFromFilter),
      take(1)
    ).subscribe(from => {
      if (dateWithTimeZone && dateWithTimeZone.slice(0, 10) !== from.slice(0, 10)) {

        this.store.dispatch(new SetValuationsFromFilterAction(dateWithTimeZone));
        if (this.chart) {
          this.chart.setExtremesFrom(moment.utc(dateWithTimeZone).valueOf());
        }
      }
    });
  }

  /**
   * Maintains To filter value in store
   * Sets extreme max value on chart
   */
  public onChangeTo(event: string): void {
    const formatted = DateTime.fromJSDate(event).toFormat('yyyy-MM-dd');
    const dateWithTimeZone = new Date(formatted + 'T00:00:00.000Z').toISOString()
    this.store.pipe(
      select(selectValuationsToFilter),
      take(1)
    ).subscribe(to => {

      if (dateWithTimeZone && dateWithTimeZone.slice(0, 10) !== to.slice(0, 10)) {
        this.store.dispatch(new SetValuationsToFilterAction(dateWithTimeZone));
        if (this.chart) {
          this.chart.setExtremesTo(moment.utc(dateWithTimeZone).valueOf());
        }
      }
    })
  }

  public onExportPDF(): void {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectValuationsFunds)),
    //   this.store.pipe(select(selectValuationsFilter)),
    //   this.store.pipe(select(selectStaticData)),
    //   this.store.pipe(select(selectMainPageNotes)),
    //   this.store.pipe(select(selectConsultants))
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectValuationsFunds)),
      this.store.pipe(select(selectValuationsFilter)),
      this.store.pipe(select(selectStaticData)),
      this.store.pipe(select(selectMainPageNotes)),
      this.store.pipe(select(selectConsultants)),
      this.showRangeStrategic$
    ]).pipe(
      map(([account, client, funds,
        filter, staticData, pageNotes, consultants, showRangeStrategic]) => ({
          client: client.name,
          price: filter.price,
          from: filter.from,
          to: filter.to,
          funds: [...funds].sort(ValuationsContainerComponent.sortFunds),
          staticData,
          account,
          pageNotes,
          consultants,
          showRangeStrategic,
          country: this.country
        })),
      take(1)
    ).subscribe(payload => {
      if (!!payload.account && !!payload.funds.length) {
        const mmcLogo = [],
          mercerLogo = [],
          icons = [],
          promises = [];
        promises.push(getDataUri('assets/images/mmc_logo.png', CommonConstants.pdfMmcLogoWidth, CommonConstants.pdfMmcLogoHeight)
          .then(data => mmcLogo.push(data)));
        promises.push(getDataUri('assets/images/mercer_brand_logo.png',
          CommonConstants.pdfMercerLogoWidth, CommonConstants.pdfMercerLogoHeight)
          .then(data => mercerLogo.push(data)));
        promises.push(getDataUri('assets/images/phone.png', 18, 18)
          .then(data => icons['phone'] = data));
        promises.push(getDataUri('assets/images/email.png', 18, 18)
          .then(data => icons['email'] = data));
        promises.push(getDataUri('assets/images/website.png', 18, 18)
          .then(data => icons['website'] = data));
        setTimeout(() => {
          Promise.all(promises).then(() => {
            const date =
              `${formatDate(payload.from, CommonConstants.displayDateFormatInAU, true)} - ${formatDate(payload.to,
                CommonConstants.displayDateFormatInAU, true)}`.toUpperCase(),
              price = this.prices.find(price => price.value === payload.price).label,

              priceType = payload.price as keyof Types,
              pageNotes: PageNotes = payload.pageNotes;

            let pdfWidth = ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
              pdfTableHead = [
                { text: 'NAME', style: 'tableHeader' },
                { text: price.toUpperCase(), style: 'tableHeader' },
                { text: 'UNITS HELD', style: 'tableHeader' },
                { text: 'LAST VALUATION DATE', style: 'tableHeader' },
                { text: 'CLOSING BALANCE ($)', style: 'tableHeader' },
                { text: 'ACTUAL (%)', style: 'tableHeader' },
                { text: 'STRATEGIC (%)', style: 'tableHeader' },
                { text: 'RANGE MIN/MAX (%)', style: 'tableHeader' }
              ],
              pdfTableRecord = payload.funds.map(fund => {
                const priceData = {
                  price: fund.price as Types,
                  closing: fund.closing as Types,
                  actual: fund.actual as Types
                };
                return [
                  { text: fund.name || '-', style: 'textCell' },
                  { text: fund.price ? this.decimal.transform(priceData.price[priceType]) : '-', style: 'numberCell' },
                  { text: fund.units ? this.decimal.transform(fund.units) : '-', style: 'numberCell' },
                  {
                    text: fund.latestValuation ?
                      formatDate(fund.latestValuation, CommonConstants.simpleDateFormatInAU, true) : '-', style: 'textCell'
                  },
                  { text: fund.closing ? this.decimal.transform(priceData.closing[priceType]) : '-', style: 'numberCell' },
                  { text: fund.actual ? this.decimal.transform(priceData.actual[priceType]) : '-', style: 'numberCell' },
                  { text: fund.strategic ? this.decimal.transform(fund.strategic) : '-', style: 'numberCell' },
                  { text: fund.range ? fund.range : '-', style: 'numberCell' },
                ];
              });
            if (payload.showRangeStrategic === false) {
              pdfWidth = pdfWidth.slice(0, -2); // remove last 2 elements from width
              pdfTableHead = pdfTableHead.slice(0, -2); // remove last 2 elements from header
              pdfTableRecord = pdfTableRecord.map(record => record.slice(0, -2)); // remove last 2 elements from data records
            }
            const address = [];
            address.push(
              {
                text: !isNullOrUndefined(payload.staticData.entityName) ?
                  `${payload.staticData.entityName}` : '', style: 'clientTitle', pageBreak: 'before'
              },
              {
                text: !isNullOrUndefined(payload.staticData.address) ?
                  `${payload.staticData.address}` : '', style: 'clientAddress'
              },
            );
            const docDefinition = {
              content: [
                { text: 'Valuation Report', style: 'title' },
                { text: date, style: 'subtitle' },
                { text: `${payload.client} - ${payload.account.name} - ${payload.account.number}`, style: 'subsubtitle' },
                { text: 'Date Generated: ' + moment.utc().format(CommonConstants.displayDateFormatInAU), style: 'subtitleDate' },
                { text: 'Investment Details', style: 'chartTitleNew' },
                { text: `As at ${formatDate(payload.to, 'DD-MM-YYYY')}`, style: 'chartTitleNew' },
                {
                  text: [
                    { text: 'Unit Price Type:', margin: [0, 5] },
                    { text: ` ${price} ` }
                  ], style: 'subChartTitleNew'
                },
                {
                  table: {
                    headerRows: 1,
                    widths: pdfWidth,
                    body: [
                      pdfTableHead,
                      ...pdfTableRecord
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return 1;
                    },
                    vLineWidth: function (i, node) {
                      return 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },
                  }
                },
                { text: CommonConstants.notes, style: 'notesTitle', pageBreak: 'before' },
                { text: `${pageNotes.valuation.details.replace(/<br\/>/g, '\n')}`, style: 'notesData', pageBreak: 'after' },
                ...payload.consultants.map(consultant =>
                ([
                  { text: `${consultant.firstName} ${consultant.lastName}` || '', style: 'consultantName' },
                  {
                    columns: [
                      // { image: icons['phone'], width: 15, height: 11, margin: [0, 0, 0, 10] },
                      { text: `${consultant.phone}` || '', style: 'consultantPhone' }
                    ]
                  },
                  {
                    columns: [
                      // { image: icons['email'], width: 15, height: 11, margin: [0, 0, 0, 10] },
                      { text: `${consultant.username}` || '', style: 'consultantMail' },
                    ]
                  },
                ]
                )),
                { text: 'Mercer Multi Manager Fund Contact Details', style: 'fundContactTitle' },
                {
                  columns: [
                    // { image: icons['phone'], width: 15, height: 11, margin: [0, 0, 0, 10] },
                    { text: `${payload.staticData.phone || ''}`, style: 'fundContactPhone' }
                  ]
                },
                {
                  columns: [
                    // { image: icons['email'], width: 15, height: 11, margin: [0, 0, 0, 10] },
                    { text: `${payload.staticData.email || ''}`, style: 'fundContactEmail' }
                  ]
                },
                {
                  columns: [
                    // { image: icons['website'], width: 15, height: 11, margin: [0, 0, 0, 10] },
                    { text: `${payload.staticData.website || ''}`, style: 'fundContactWebsite' }
                  ]
                },
                { text: CommonConstants.importantNotices, style: 'noticeTitle', pageBreak: 'before' },
                { text: payload.staticData.importantNotices, style: 'noticeData' },
                ...address

              ],
              styles: {
                ...pdfStyle,
              },
              footer(currentPage: number, totalPages: number) {
                return pdfFooter(currentPage, totalPages, payload, mmcLogo[0]);
              },
              header(currentPage: number, totalPages: number) {
                return pdfHeader(mmcLogo, 'Valuation Report', currentPage, totalPages);
              },
              pageMargins: [40, 90, 40, 100]
            };

            pdfMake.vfs = {
              ...(pdfFonts.pdfMake as any).vfs,
              ...georgiaFontVfs
            };
            pdfMake.fonts = {
              ...georgiaFontFamily,
              Roboto: {
                normal: 'Roboto-Regular.ttf',
                bold: 'Roboto-Medium.ttf',
                italics: 'Roboto-Italic.ttf',
                bolditalics: 'Roboto-MediumItalic.ttf'
              }
            };
            pdfMake.createPdf(docDefinition).download('ValuationExport.pdf');
          });
        }, 1000);
      } else if (!payload.account) {
        //this.store.dispatch(new AddErrorToastAction('Please select an Account'));
        return this._toasterService.launchAlertError('Please select an Account', Actions.error);
      } else {
        // this.store.dispatch(new AddErrorToastAction(
        //   `There is no data in specified date range from ` +
        //   `${formatDate(payload.from, CommonConstants.DBDateFormat, true)} to ` +
        //   `${formatDate(payload.to, CommonConstants.DBDateFormat, true)}.`
        // ));
        return this._toasterService.launchAlertError(`There is no data in specified date range from ` +
          `${formatDate(payload.from, CommonConstants.DBDateFormat, true)} to ` +
          `${formatDate(payload.to, CommonConstants.DBDateFormat, true)}`, Actions.error);
      }
    });
  }

  public onExportCSV(exportType: CsvExportType): void {
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectValuationsFunds)),
      this.store.pipe(select(selectValuationsFromFilter)),
      this.store.pipe(select(selectValuationsToFilter)),
      this.store.pipe(select(selectValuationsPriceFilter)),
      this.store.pipe(select(selectValuationsTypeFilter)),
      this.store.pipe(select(selectValuationsFundFilter)),
      this.store.pipe(select(selectValuationsFundsFilter))]
    ).pipe(
      map(([account, allFunds, from, to, price, type, fund, funds]) => ({
        // @ts-ignore
        account: !!account ? account._id : undefined,
        priceType: price,
        // @ts-ignore
        from: from ? formatDate(from, CommonConstants.DBDateFormat, true) : '',
        // @ts-ignore
        to: to ? formatDate(to, CommonConstants.DBDateFormat, true) : '',
        userDate: DateTime.local().toFormat('dd/MM/yyyy h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
        type,
        exportType,
        country: this.country,
        // @ts-ignore
        funds: exportType === CsvExportType.REGULAR ? [] : this.getFundsPayload(type, allFunds, fund, funds)
      })),
      withLatestFrom(this.tableLength$),
      take(1)
    ).subscribe(([payload, tableLength]) => {
      if (!payload.account) {
        //this.store.dispatch(new AddErrorToastAction('Please select an Account'));
        return this._toasterService.launchAlertError('Please select an Account', Actions.error);
      } else if (payload.exportType === 'history' && payload.funds.length === 0) {
        //this.store.dispatch(new AddErrorToastAction('Please select an option from the "Select Your Option" menu'));
        return this._toasterService.launchAlertError('Please select an option from the "Select Your Option" menu', Actions.error);
      } else if (!!payload.account && tableLength > 1) {
        // @ts-ignore
        this.store.dispatch(new ValuationsCsvExportAction(payload));
      } else {
        //this.store.dispatch(new AddErrorToastAction(
        //`There is no data in specified date range from ${payload.from} to ${payload.to}.`
        //  ));
        return this._toasterService.launchAlertError(`There is no data in specified date range from ${payload.from} to ${payload.to}.`, Actions.error);
      }
    });
  }
  public onSort(name, direction): void {
    let sortObj: SortInfo = { column: '', reverse: false }
    if (direction && name) {
      sortObj.column = name
      if (direction === 'initial' || direction === 'asc') {
        sortObj.reverse = false
      }
      if (direction === 'desc') {
        sortObj.reverse = true
      }
      this.sort$.next(sortObj);
    }
  }

  /**
   * Reloads Valuations Portfolio data on Main Account change
   * Min and Max dates must be loaded before action is dispatched
   */
  private subscribeLoadValuationsPortfolio(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectValuationsDates)),
    //   this.store.pipe(select(selectValuationsFilter)),
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectValuationsDates)),
      this.store.pipe(select(selectValuationsFilter))]
    ).pipe(
      map(([dates, filter]) => (
        [dates, { from: filter.from, to: filter.to }])
      ),
      distinctUntilChanged(isEqual)
    ).pipe(
      filter(([dates, filter]) =>
        dates !== undefined && filter.from !== undefined && filter.to !== undefined
      ),
      map(([dates, filter]) => (
        { from: filter.from, to: filter.to }
      ))
    ).subscribe(payload => {
      if (!!this.account) {
        payload['account'] = this.account['_id'];
        this.store.dispatch(new LoadValuationsPortfolioAction(payload as any));
      }
    });
  }

  /**
   * Reloads Valuations Prices data on Main Account change
   * Data is loaded for all funds of selected account
   */
  private subscribeLoadValuationsPrices(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectValuationsPayloadFunds)),
    //   this.store.pipe(select(selectValuationsFromFilter)),
    //   this.store.pipe(select(selectValuationsToFilter)),
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectValuationsPayloadFunds)),
      this.store.pipe(select(selectValuationsFromFilter)),
      this.store.pipe(select(selectValuationsToFilter))]
    ).pipe(
      filter(([funds, from, to]) => funds !== undefined && !!from && !!to),
      map(([funds, from, to]) => ({ funds, from, to }))
    ).subscribe(payload => {
      if (this.account !== undefined) {
        payload['account'] = this.account['_id'];
        this.store.dispatch(new LoadValuationsPricesAction(payload as any));
      }
    });
  }

  /**
   * Reloads Valuations Total Prices data on Main Account change
   * Uses same endpoint as regular Valuations Prices
   * Sends an empty string as payload instead of list of fund id's
   */
  private subscribeLoadValuationsTotalPrices(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectValuationsPayloadFunds)),
    //   this.store.pipe(select(selectValuationsFromFilter)),
    //   this.store.pipe(select(selectValuationsToFilter)))
    return combineLatest([
      this.store.pipe(select(selectValuationsPayloadFunds)),
      this.store.pipe(select(selectValuationsFromFilter)),
      this.store.pipe(select(selectValuationsToFilter))])
      .pipe(
        filter(([funds, from, to]) => funds !== undefined && !!from && !!to),
        map(([funds, from, to]) => ({ funds, from, to })),
      ).subscribe(payload => {
        if (this.account !== undefined) {
          payload['account'] = this.account['_id'];
          payload.funds = '';
          this.store.dispatch(new LoadValuationsTotalPricesAction(payload));
        }
      });
  }


  private subscribePriceFilter(): Subscription {
    return this.store.pipe(
      select(selectValuationsPriceFilter)
    ).subscribe(price => {
      this.price = price;
    });
  }

  private subscribeFundsFilter(): Subscription {
    return this.store.pipe(
      select(selectValuationsFundsFilter)
    ).subscribe(funds => {
      setTimeout(() => {
        this.funds = funds;

        if (!this.cdr['destroyed']) {
          this.cdr.detectChanges();
        }
      });

    });
  }

  private subscribeResetFilters(): Subscription {
    return this.store.pipe(
      select(selectValuationsPortfolio)
    ).subscribe(portfolio => {
      if (!portfolio.funds.length) {
        this.store.dispatch(new SetValuationsFundsFilterAction(['total']));
      }
    });
  }

  private subscribeResetData(): Subscription {
    return this.store.pipe(
      select(selectMainFilterSelectedAccount)
    ).subscribe(account => {
      if (!account) {
        this.store.dispatch(new ResetValuationsDataAction());
        this.from = '';
        this.to = '';
      } else {
        this.account = account;
        if (this.chart) {
          this.chart.setRangeSelection(5);
        }
      }
    });
  }

  private subscribeInitialFundFilter(): Subscription {
    return this.store.pipe(
      select(selectValuationsFunds),
      filter(funds => !!funds.length),
      map(funds => [...funds].shift().fundId)
    ).subscribe(fund => {
      this.store.dispatch(new SetValuationsFundFilterAction([fund]));
    });
  }

  private subscribeFundFilter(): Subscription {
    return this.store.pipe(
      select(selectValuationsFundFilter)
    ).subscribe(fund => {
      this.fund = fund[0];
    });
  }

  private setInitialFromToFilter(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectValuationsDates))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectValuationsDates))]
    ).pipe(
      filter(([dates]) => dates && dates.min !== undefined && dates.max !== undefined)
    ).subscribe((dates) => {
      this.store.dispatch(new SetValuationsToFilterAction(dates['max']));
      this.store.dispatch(new SetValuationsFromFilterAction(dates['min']));
    });
  }

  /**
   * Sets value of From filter on the component level
   * For first time users, set From filter in store to Min date
   * Returning users should see last selected value
   */
  private subscribeInitialFromFilter(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectValuationsDates)),
    //   this.store.pipe(select(selectValuationsFromFilter))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectValuationsDates)),
      this.store.pipe(select(selectValuationsFromFilter))]
    ).pipe(
      filter(([dates]) => dates && dates.min !== undefined)
    ).subscribe(([dates, from]) => {
      this.from = from === undefined ? ValuationsContainerComponent.getFromDate(dates) : from;

      if (from === undefined) {
        this.store.dispatch(new SetValuationsFromFilterAction(this.from));
      }
    });
  }

  /**
   * Sets value of To and asAt filters on the component level
   * For first time users, set To and asAt filters in store to Max date
   * Returning users should see last selected value
   * asAt is used on mobile instead of date range selection
   */
  private subscribeInitialToFilter(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectValuationsDatesMax)),
    //   this.store.pipe(select(selectValuationsToFilter))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectValuationsDatesMax)),
      this.store.pipe(select(selectValuationsToFilter))]
    ).pipe(
      filter(([max]) => max !== undefined)
    ).subscribe(([max, to]) => {
      this.to = this.asAt = to === undefined ? max : to;
      if (to === undefined) {
        this.store.dispatch(new SetValuationsToFilterAction(max));
      }
    });
  }

  private subscribeIsMobile(): Subscription {
    return this.resize.mobile$.subscribe(this.isMobile$);
  }

  private subscribeFilterTypes(): Subscription {
    return this.isMobile$.pipe(
      map(isMobile => !isMobile ? this.filterTypes : this.mobileFilterTypes)
    ).subscribe(this.filterTypes$);
  }

  private subscribeNotes(): Subscription {
    return this.store.pipe(
      select(selectMainPageNotes)
    ).subscribe(this.notes$);
  }

  private selectLoading(): Observable<boolean> {
    // return combineLatest(
    //   this.store.pipe(select(selectValuationsLoading)),
    //   this.store.pipe(select(selectValuationsDataLoading))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectValuationsLoading)),
      this.store.pipe(select(selectValuationsDataLoading))]
    ).pipe(
      map(([loading, dataLoading]) => loading || dataLoading)
    );
  }

  private selectHeaders(): Observable<ColumnDef[]> {
    return combineLatest([
      this.store.pipe(select(selectValuationsPriceFilter)),
      this.showRangeStrategic$
    ]).pipe(
      map(([filter, showRangeStrategic]) => {
        let headers = [...this.headers];
        if (showRangeStrategic === false) {
          headers = headers.slice(0, -2); // remove last 2 elements from header
        }
        const price = this.prices.find(price => price.value === filter);
        headers[1].name = price.label;

        return headers;
      })
    );
  }

  private selectShowTotal(): Observable<boolean> {
    return this.store.pipe(
      select(selectValuationsFundsFilter),
      map(funds => funds.includes('total'))
    );
  }

  private selectDate(): Observable<string> {
    return this.store.pipe(
      select(selectValuationsToFilter),
      map(date => formatDate(date, CommonConstants.simpleDateFormatInAU, true))
    );
  }

  private selectMinDate(): Observable<string | undefined> {
    return this.store.pipe(
      select(selectValuationsDatesMin),
      map(min => min ? formatDate(min, CommonConstants.DBDateFormat, true) : undefined)
    );
  }

  private selectMaxDate(): Observable<string | undefined> {
    return this.store.pipe(
      select(selectValuationsDatesMax),
      map(max => max ? formatDate(max, CommonConstants.DBDateFormat, true) : undefined)
    );
  }

  private selectTypeFilter(): Observable<ValuationsType | PriceType> {
    return this.store.pipe(
      select(selectValuationsTypeFilter),
      distinctUntilChanged()
    );
  }

  private selectFunds(): Observable<ValuationsFund[]> {
    return this.store.pipe(
      select(selectValuationsFunds),
      map(funds => sortBy(funds, 'name'))
    );
  }

  private subscribeFundList(): Subscription {

    return this.funds$.subscribe(funds => {

      this.fundlist = []
      if (this.fundlist.length <= 0) {

        this.fundlist.push({
          fundId: 'total',
          name: 'Total Portfolio'
        } as ValuationsFund);
      }
      if (this.fundlist.length === 1 && funds && funds.length > 0) {

        funds.forEach(element => {
          this.fundlist.push(element);
        })
      }
      this.fundsOptions = this.fundlist.map(fund => ({
        label: fund.name,
        value: fund.fundId,
      }));
      this.fundsOptions = this.fundsOptions.map(option => {
        return {
          ...option,
          selected: option.label === "Total Portfolio"
        };
      });
    });


  }

  private selectPagination(): Observable<PaginationInfo> {
    return this.store.pipe(
      select(selectValuationsFunds),
      filter(funds => !!funds.length),
      map(funds => ({
        page: 1,
        itemsByPage: funds.length,
        total: funds.length
      }))
    );
  }

  private subscribeShowData(): Subscription {
    return this.store.pipe(
      select(selectValuationsPortfolio),
      map(portfolio => !!portfolio.funds.length)
    ).subscribe(this.showData$);
  }

  /**
   * Builds table data from Valuations Portfolio
   */
  private selectTable(): Observable<ValuationsTableFund[]> {
    // return combineLatest(
    //   this.store.pipe(select(selectValuationsPortfolio)),
    //   this.store.pipe(select(selectValuationsFilter)),
    //   this.sort$
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectValuationsPortfolio)),
      this.store.pipe(select(selectValuationsFilter)),
      this.sort$]
    ).pipe(
      map(([portfolio, filter, sort]) => {
        const fund = filter.fund,
          funds = filter.funds,
          price = filter.price,
          type = filter.type;

        /** Stop if there aren't any funds in portfolio */
        if (!portfolio.funds.length) {
          this.tableLength$.next(0);
          return [];
        }

        let highlighted: ValuationsTableFund[] = [],
          data: ValuationsTableFund[] = [];
        const priceType = price as keyof Types;

        /**
         * Add each fund as row to table data
         */
        [...portfolio.funds].forEach(item => {

          /**
           *  COMMENTED : to get the rows for table to made for the 'funds' to display
           */
          // if (item.latestValuation < from || item.latestValuation > to) {
          //   return;
          // }

          /** Check whether fund is selected in filter based on Valuations Type filter */
          const selected = (type === ValuationsTypes.PRICE ? funds : fund).includes(item.fundId),
            priceData = {
              price: item.price as Types,
              closing: item.closing as Types,
              actual: item.actual as Types
            },

            row = {
              ...item,
              selected,
              latestValuation: formatDate(item.latestValuation, CommonConstants.simpleDateFormatInAU, true),
              price: priceData.price[priceType],
              closing: priceData.closing[priceType],
              actual: priceData.actual[priceType]
            };

          /**
           * If fund is selected in filter, add it to highlighted array
           * otherwise add it to data
           */
          (selected ? highlighted : data).push(row);
        });

        /** Sort highlighted entries */
        highlighted = sort.reverse
          ? this.sort(highlighted, sort).reverse()
          : this.sort(highlighted, sort);

        /** Sort not highlighted entries */
        data = sort.reverse
          ? this.sort(data, sort).reverse()
          : this.sort(data, sort);

        const closingBalance = portfolio.closingBalance as Types,
          closingActual = portfolio.closingActual as Types,

          /**
           * Insert Total Portfolio row, followed by highlighted rows
           * and remaining data rows
           */
          table = [
            {
              fundId: null,
              selected: false,
              name: CommonConstants.totalPortfolio,
              latestValuation: null,
              price: null,
              units: null,
              closing: closingBalance[priceType],
              actual: closingActual[priceType],
              strategic: null,
              range: null
            },
            ...highlighted,
            ...data
          ];

        this.tableLength$.next(table.length);

        if ((table.slice(1).find(element => element.range != null) !== undefined) ||
          (table.slice(1).find(element => element.strategic != null) !== undefined)
        ) {
          this.showRangeStrategic$.next(true);
        } else {
          this.showRangeStrategic$.next(false);
        }
        return table;
      }),
    );
  }

  private sort(funds: ValuationsTableFund[], sort: SortInfo): ValuationsTableFund[] {
    switch (sort.column) {
      case 'price':
      case 'units':
      case 'closing':
      case 'actual':
      case 'strategic':
        const column = sort.column as keyof ValuationsTableFund;
        return sortBy(funds, fund => +fund[column]);
      default:
        return sortBy(funds, sort.column);
    }
  }

  private getFundsPayload(type: ValuationsType | PriceType, allFunds: ValuationsFund[], fund: string[], funds: string[]) {
    const selected = (type === ValuationsTypes.PRICE ? funds : fund);
    if (selected.indexOf('total') === -1) {
      return selected.map(f => allFunds.filter(a => a.fundId === f).reduce((acc, item) => ({ name: item.name, id: item.fundId }), {}));
    } else if (selected.indexOf('total') === 0 && selected.length === 1) {
      return [{ id: 'total', name: CommonConstants.totalPortfolio }];
    } else {
      let totalFunds = selected.map(f => allFunds.filter(a => a.fundId === f)
        .reduce((acc, item) => ({ name: item.name, id: item.fundId }), {}));
      totalFunds.unshift({ id: 'total', name: CommonConstants.totalPortfolio });
      totalFunds = totalFunds.filter(value => Object.keys(value).length !== 0);
      return totalFunds;
    }
  }

  private subscribeChartData(): Subscription {
    return this.store.pipe(
      select(selectValuationsChartPayload),
      filter(payload => payload !== undefined),
    ).subscribe(payload => {
      /**
       * Remove all series from chart before continuing
       * This effectively resets the chart without recreating it
       */
      this.chart.removeAllSeries();

      const series = [];

      if (payload.filter.type === ValuationsTypes.PRICE) {
        /**
         * If Funds filter includes option 'total', use Total Prices data
         * Otherwise, use Prices data
         */
        if (payload.filter.funds.includes('total')) {
          /** Map Total Prices data values to series of points */
          const points = [];
          if (payload.total && payload.total.values) {
            for (let i = 0; i < payload.total.values.length; i++) {
              const point = payload.total.values[i];

              points.push({
                x: moment.utc(point.date).valueOf(),
                y: +point[`${payload.filter.price}Price`],
                tooltip: point[`${payload.filter.price}Price`]
              });
            }

            series.push({
              color: '#0FB694',
              showInNavigator: true,
              name: CommonConstants.totalPortfolio,
              data: sortBy(points, point => point[0])
            });
          }
        }

        if (payload.filter.funds.length > 1 || !payload.filter.funds.includes('total')) {
          for (let i = 0; i < payload.prices.length; i++) {
            const price = payload.prices[i];

            if (!payload.filter.funds.includes(price.fundId)) {
              continue;
            }
            const fund = payload.funds.find(fund => fund.fundId === price.fundId),
              points = [];
            for (let j = 0; j < price.values.length; j++) {
              const value = price.values[j];

              points.push({
                x: moment.utc(value.date).valueOf(),
                y: +value[`${payload.filter.price}Value`],
                tooltip: value[`${payload.filter.price}Value`],
                id: fund.fundId
              });
            }

            series.push({
              color: `rgba(${RGB_COLORS[i].r}, ${RGB_COLORS[i].g}, ${RGB_COLORS[i].b}, 1)`,
              showInNavigator: true,
              name: fund.name,
              data: sortBy(points, point => point.x)
            });
          }
        }
      } else {
        const points = [],

          price = payload.prices.find(price => price.fundId === payload.filter.fund);

        for (let i = 0; i < price.values.length; i++) {
          const value = price.values[i];

          points.push({
            x: moment.utc(value.date).valueOf(),
            y: +value[FULL_PRICE_TYPES[payload.filter.price]],
            tooltip: value[FULL_PRICE_TYPES[payload.filter.price]]
          });
        }

        series.push({
          color: '#0FB694',
          name: PRICE_TYPES.find(type => type.value === payload.filter.price).label,
          data: points
        });
      }

      /**
       * Redraw chart only when the last serie is added
       * This does not create a new chart object but modifies existing one instead
       */
      series.forEach((serie, index) => {
        this.chart.addSerie(serie, series.length - 1 === index);
      });
    });
  }

  private createBaseChart(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectClientCurrency)),
    //   this.store.pipe(select(selectValuationsDates)),
    //   this.store.pipe(select(selectCountrySelected))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectClientCurrency)),
      this.store.pipe(select(selectValuationsDates)),
      this.store.pipe(select(selectCountrySelected))]
    ).pipe(
      filter(([currency, dates, country]) => currency !== undefined && dates !== undefined
        && country !== undefined),
      // take(1),
      distinctUntilChanged(isEqual)
    ).subscribe(([currency, dates, country]) => {
      const pipe = this.decimal;

      this.chart = new StockChart({
        chart: {
          plotBorderWidth: 1,
          style: {
            fontFamily: CommonConstants.semanticFontFamilyPlain,
          },
          events: {
            load() {
              if (this.container) {
                const svgWidth = this.container.offsetWidth,
                  interval = setInterval(() => {
                    if (this.container && this.container.offsetWidth !== 0 && svgWidth !== this.container.offsetWidth) {
                      clearInterval(interval);
                      this.reflow();
                    } else if (!this.container || svgWidth === this.container.offsetWidth) {
                      clearInterval(interval);
                    }
                  }, 100);
              }
            }
          }
        },
        title: {
          style: {
            display: 'none'
          }
        },
        credits: {
          enabled: false
        },
        navigator: {
          xAxis: {
            allowDecimals: false
          }
        },
        xAxis: {
          tickLength: 0,
          type: 'datetime',
          dateTimeLabelFormats: {
            day: '%e / %m'
          },
        } as XAxisOptions,
        yAxis: {
          opposite: false,
          tickPixelInterval: 50,
          title: {
            text: `Investments ${currency} $`,
            style: {
              color: '#000000',
              fontSize: CommonConstants.chartFontSizeLarge,
              fontFamily: CommonConstants.semanticFontFamilyPlain
            }
          },
          labels: {
            formatter() {
              return pipe.transform(this.value.toString());
            },
            style: {
              fontWeight: CommonConstants.chartFontWeightNumeric,
              fontSize: CommonConstants.chartFontSizeSmall,
              fontFamily: CommonConstants.semanticFontFamilyPlain
            }
          }
        },
        series: [],
        exporting: {
          enabled: true
        },
        legend: {
          enabled: true,
          symbolHeight: 500,
          itemStyle: {
            fontFamily: CommonConstants.semanticFontFamilyPlain
          }
        },
        plotOptions: {
          series: {
            turboThreshold: 0,
          },
          line: {
            turboThreshold: 0,
            marker: {
              radius: 0
            },
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 1
              }
            },
            // threshold: null
          }
        },
        tooltip: {
          enabled: true,
          useHTML: true,
          shared: true,
          style: {
            fontFamily: CommonConstants.semanticFontFamilyPlain
          },
          pointFormatter() {
            return `
              <span style="display: block; font-size: 10px">${moment.utc(this.x).format('dddd, MMM  D YYYY')}</span>
              <span style="color: ${this.color}">●</span>
              <span>${this.series.name}:</span>
              <span style="font-weight: bold">$ ${pipe.transform(this.y.toPrecision())}</span>
            `;
          }
        }
      });
    });
  }
  // <span style="font-weight: bold">$uuu ${pipe.transform(this.y)}</span>
  // <span style="font-weight: bold">$jjj ${pipe.transform(this.tooltipFormatter(this.y.toString()))}</span>
  getMin(a: number, b: number): number {
    return Math.min(a, b);
  }

}
